'use client';

import { PropsWithChildren } from 'react';

import { clsx } from 'clsx';

import { Analytics } from '@monoimin/utils/analytics';
import { trackAmplitudeEvent } from '@monoimin/analytics';
import { SharedLink, LinkButton, GhostLink } from '@monoimin/atoms';
import { LinkButtonProps } from '@monoimin/atoms/components/button/constants';

import type { C2AAnalyticsClientProps } from '@monoimin/sb-types';

export default function NewC2ALinkClient({
  href,
  data,
  children,
  fullSizeOverlay,
  icon,
  variant,
  buttonType,
  className,
  theme,
}: PropsWithChildren<
  LinkButtonProps & {
    data?: C2AAnalyticsClientProps;
    buttonType?: 'empty' | 'button' | 'ghost';
    theme?: LinkButtonProps['theme'];
    href: string;
  }
>) {
  const analyticsClickHandler = () => {
    if (data) {
      c2aSendButtonClickEventData(data);
    }
  };

  if (buttonType === 'empty') {
    return (
      <div onClick={analyticsClickHandler}>
        <SharedLink
          href={href}
          underlineSize={0}
          target='_blank'
          underline='off'
          fullSizeOverlay={fullSizeOverlay}
        >
          {children}
        </SharedLink>
      </div>
    );
  }
  if (buttonType === 'ghost') {
    return (
      <div onClick={analyticsClickHandler}>
        <GhostLink
          href={String(href).replace('shared', '')}
          icon={icon}
          target='_blank'
          className={clsx(className, 'body')}
          fullSizeOverlay={fullSizeOverlay}
        >
          {children}
        </GhostLink>
      </div>
    );
  }
  return (
    <div onClick={analyticsClickHandler}>
      <LinkButton
        href={String(href).replace('shared', '')}
        variant={variant}
        icon={icon}
        target='_blank'
        theme={theme}
        className={className}
        fullSizeOverlay={fullSizeOverlay}
      >
        {children}
      </LinkButton>
    </div>
  );
}

export function c2aSendButtonClickEventData(data: C2AAnalyticsClientProps) {
  const EVENT_NAME = 'CTA Block Click';

  const renta = new Analytics();
  renta.track(EVENT_NAME, data);

  trackAmplitudeEvent({
    deviceId: '',
    userId: null,
    name: EVENT_NAME,
    properties: { ...data, event_type: 'click' },
  });

  if (typeof window !== 'undefined' && window?.dataLayer?.push) {
    window.dataLayer.push({
      event: EVENT_NAME,
      cta_block_category: data.block_type,
      cta_block_name: data.block_name as string,
      attribute_url: data.element_click_url as string,
    });
  }
}
